(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cl-footer-menu"] && !Shopify.designMode) return;
  try {
    // Accordion functionality já funciona nativamente com o elemento <details>
  // Este script adiciona funcionalidade extra se necessário
  
  class FooterMenuAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Previne que links dentro de summary naveguem quando há filhos
      const summaries = this.querySelectorAll('.cl-footer-menu__link--parent');
      summaries.forEach(summary => {
        summary.addEventListener('click', (e) => {
          // O comportamento padrão do details/summary já funciona
          // Este listener é apenas para customizações futuras
        });
      });
    }
  }

  if (!customElements.get('footer-menu-accordion')) {
    customElements.define('footer-menu-accordion', FooterMenuAccordion);
  }
  } catch(e) { console.error(e); }
})();

})();
